import axios from "axios";

const apiRequest = axios.create({
  baseURL: process.env.REACT_APP_AUTH0_DOMAIN,
});

export const verifyEmail = async (params) => {
  const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const token = process.env.REACT_APP_AUTH0_MGMT_ACCESS_TOKEN;
  const auth = await apiRequest
    .post(
      "/api/v2/jobs/verification-email",
      {
        user_id: params.user_id,
        client_id: auth0ClientId,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    )
    .catch((error) => error?.response);
  return auth;
};
